import { render, staticRenderFns } from "./InitLogin.vue?vue&type=template&id=50fb225a"
import script from "./InitLogin.vue?vue&type=script&lang=js"
export * from "./InitLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports